"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useInView } from "@/hooks/useInView";
import { ScrollReveal } from "./ScrollReveal";
import { LandingSectionHeader } from "./LandingSectionHeader";
import { useCases } from "./homepage-data";

export function LandingUseCases() {
  const [sectionRef, isVisible] = useInView<HTMLElement>(0.05);

  return (
    <section ref={sectionRef} className="bg-[hsl(var(--lb-bg-soft))] py-8 sm:py-14">
      <div className="lb-container">
        <ScrollReveal>
          <LandingSectionHeader
            eyebrow="Who it is for"
            title="Built for the role you actually do."
            copy="Vehicle devs, server owners, livery and EUP creators, resource builders — same workspace, different starting points."
          />
        </ScrollReveal>

        <div className="mt-10 grid border-t border-black/10 md:grid-cols-2">
          {useCases.map((useCase, index) => (
            <Link
              key={useCase.title}
              to="#pricing"
              className="group block min-h-[26rem] border-b border-black/10 p-8 transition hover:bg-[hsl(var(--lb-panel-strong))] md:border-r md:even:border-r-0 sm:p-10"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "none" : "translateY(28px)",
                transition: `opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${index * 100}ms, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${index * 100}ms`,
              }}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-xl tracking-[0.1em] text-black/30">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <ArrowUpRight className="h-7 w-7 text-black/28 transition group-hover:text-black" />
              </div>
              <h3 className="mt-16 max-w-xl text-[3rem] font-semibold leading-[0.95] tracking-[-0.075em] text-black">
                {useCase.title}
              </h3>
              <p className="mt-8 max-w-xl text-xl leading-[1.45] tracking-[-0.035em] text-black/58">
                {useCase.copy}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
